import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import BaseSubscriptionSelect, {
  type SubscriptionOption,
} from 'lumen/components/settings/users/base-subscription-select';

interface AddSubscriptionAccessSignature {
  Args: {
    onAdd: (subscriptionIds: number[]) => Promise<void>;
    userId: string;
  };
}

const EMPTY_SELECTION: SubscriptionOption[] = [];

export default class AddSubscriptionAccess extends BaseSubscriptionSelect<AddSubscriptionAccessSignature> {
  @service declare intl: Services['intl'];

  protected override get fetchParams(): Record<string, string | number> {
    return { ...super.fetchParams, user: this.args.userId };
  }

  @action
  buildLabel(count: number): string {
    if (count === 0) {
      return this.intl.t('settings.users.add_subscription.trigger_label');
    }

    return this.intl.t(
      'settings.users.add_subscription.trigger_label_with_count',
      { count },
    );
  }

  @action
  async handleChange(selectedOptions: SubscriptionOption[]): Promise<void> {
    if (selectedOptions.length === 0) {
      return;
    }

    const subscriptionIds = selectedOptions.map((subscription) =>
      Number(subscription.id),
    );

    await this.args.onAdd(subscriptionIds);
  }

  <template>
    <div data-test-id="add-subscription-access">
      <PrismComboSelectInput
        @buildLabelWithCount={{this.buildLabel}}
        @isSearchable={{true}}
        @onChange={{this.handleChange}}
        @onOpen={{this.onOpen}}
        @onSearch={{this.onSearch}}
        @options={{this.options}}
        @unsafe_onLoadMore={{this.loadMoreTask.perform}}
        @value={{EMPTY_SELECTION}}
      />
    </div>
  </template>
}
